import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Box, Typography, Chip } from "@mui/material";
import { ExtensionOutlined } from "@mui/icons-material";

const MaterialNode = ({ data }) => {
  return (
    <Box
      sx={{
        position: "relative",
        padding: "16px",
        borderRadius: "14px",
        background: "#ffffff",
        border: "2px solid #10b981",
        minWidth: 220,
        boxShadow: "0 6px 20px rgba(16, 185, 129, 0.15)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: "0 10px 28px rgba(16, 185, 129, 0.25)",
        },
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: "#10b981",
          width: 12,
          height: 12,
          border: "3px solid #ffffff",
          boxShadow: "0 2px 8px rgba(16, 185, 129, 0.4)",
        }}
      />

      {/* 헤더 */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "8px",
            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 3px 10px rgba(16, 185, 129, 0.3)",
          }}
        >
          <ExtensionOutlined sx={{ color: "#fff", fontSize: 18 }} />
        </Box>
        <Chip
          label="자재"
          size="small"
          sx={{
            bgcolor: "#f0fdf4",
            color: "#065f46",
            fontWeight: 600,
            fontSize: "0.7rem",
            height: 20,
          }}
        />
      </Box>

      {/* 자재명 */}
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 700,
          fontSize: "0.95rem",
          color: "#0f172a",
          mb: 1.5,
          lineHeight: 1.3,
        }}
      >
        {data.label}
      </Typography>

      {/* 수량 정보 */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 1.2,
          bgcolor: "#f0fdf4",
          borderRadius: "8px",
          border: "1px solid #d1fae5",
        }}
      >
        <Typography variant="caption" sx={{ color: "#065f46", fontSize: "0.72rem" }}>
          수량
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#047857",
            fontWeight: 700,
            fontSize: "0.85rem",
          }}
        >
          {data.quantity} {data.qty_unit}
        </Typography>
      </Box>
    </Box>
  );
};

export default MaterialNode;
